// Module
var code = "<div class=\"input-group mb-2 mt-1 ml-2\"> <span class=\"input-group-text\"></span> <a class=\"btn btn-outline-primary copy-button\" href target=\"_blank\"><i class=\"bi bi-clipboard\"></i></a> <a class=\"btn btn-outline-primary open-button\" href target=\"_blank\"><i class=\"bi bi-arrow-right-circle\"></i> {{Console_open}}</a> </div> ";
// Exports
module.exports = code;